<template>
    <v-container>
        <!--v-layout align-center justify-center-->
        <v-layout align-center justify-center>
            <v-loading class="loading" v-model="loading" v-if="loading">
    
                <v-progress-circular persistent
                :size="70"
                :width="7"
                color="primary"
                indeterminate
                ></v-progress-circular>
        
            </v-loading>
            <v-flex xs12 sm8 md4>
                <!--v-card class="elevation-12"-->
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title><a href="javascript:history.back()" class="voltar"><img class="imgVoltar" :src="imgVoltar"></a>Criar Ocorrência</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <!--v-form ref="form" v-model="valid" lazy-validation-->
                        <v-form ref="form" v-model="valid" lazy-validation>

                            <v-layout row wrap>
                                <v-flex xs11 sm5>
                                    <v-menu
                                    lazy
                                    :close-on-content-click="false"
                                    v-model="menu"
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :nudge-right="40"
                                    max-width="290px"
                                    min-width="290px"
                                    >
                                    <v-text-field
                                        slot="activator"
                                        label="Data"
                                        v-model="date"
                                        prepend-icon="event"
                                        readonly
                                    ></v-text-field>
                                    <v-date-picker v-model="date" no-title scrollable actions>
                                        <!-- <template scope="{ save, cancel }"> -->
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                            <v-btn class="buttonOk" flat color="primary" @click="save">OK</v-btn>
                                        </v-card-actions>
                                        <!-- </template> -->
                                    </v-date-picker>
                                    </v-menu>
                                </v-flex>
                            </v-layout>

                            <v-text-field name="titulo" label="Titulo" type="text"
                                            v-model="titulo">
                            </v-text-field><br />

                            <v-text-field name="descricao" label="Descrição" type="text"
                                            v-model="descricao">
                            </v-text-field><br />

                            
                            







                            <label class="v-label theme--light">Resolução da Ocorrência:</label>
                            <template>
                                <v-layout>
                                    <v-flex xs12 sm6 offset-sm3>
                                    
                                        <v-container grid-list-sm fluid>
                                        <v-layout row wrap layout fill-height align-center justify-center ma-0 custom-rating>
                                            <v-flex xs4>
                                                <label class="label-rating">Resolvido</label>
                                                <a class="layout row wrap layout fill-height align-center justify-center ma-0" @click="emogiRate('1')">
                                                    <img :src="img1" />
                                                </a>
                                                    
                                            </v-flex>
                                            
                                            <v-flex xs4>
                                                <label class="label-rating">Parcialmente</label>
                                                <a class="layout row wrap layout fill-height align-center justify-center ma-0" @click="emogiRate('2')">
                                                    <img :src="img3" />
                                                </a>
                                                    
                                            </v-flex>
                                            
                                            <v-flex xs4>
                                                <label class="label-rating">Não Resolvido</label>
                                                <a class="layout row wrap layout fill-height align-center justify-center ma-0 selected" @click="emogiRate('3')">
                                                    <img :src="img5" />
                                                </a>
                                                    
                                            </v-flex>
                                        </v-layout>
                                        </v-container>
                                    
                                    </v-flex>
                                </v-layout>
                            </template><br />
 
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <!--v-btn color="primary" :disabled="!valid" @click="submit" data-cy="joinSubmitBtn">Cadastrar</v-btn-->
                        <v-btn color="primary" :disabled="!valid || !statusUpload" @click="criarOcorrencia" data-cy="joinSubmitBtn">Criar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">{{tituloModal}}</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="closeModal">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import db from './firebaseInit';
import firebase,{ storage } from 'firebase';

import {mask} from 'vue-the-mask'

import { userProperties, usersData } from '@/global.js'

import axios from 'axios'
import VueAxios from 'vue-axios'

import img1 from '../assets/muito-feliz.png';
import img2 from '../assets/feliz.png';
import img3 from '../assets/normal.png';
import img4 from '../assets/ruim.png';
import img5 from '../assets/muito-ruim.png';

import imgVoltar from '../assets/ic-voltar.png';

//Vue.use(VueAxios, axios)

export default {
    name: 'Criar-Ocorrencia',
    directives: {mask},
    
    data: vm => ({
        imgVoltar: imgVoltar,
        img1: img1,
        img2: img2,
        img3: img3,
        img4: img4,
        img5: img5,
        valid: false,
        timestamp: null,
        dialog: false,
        loading: false,
        slug: null,
        extensao : null,
        statusUpload: true,
        tituloModal: "Ocorrência criada com sucesso!",
        date: new Date().toISOString().substr(0, 10),
        dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
        licaoCasa: false,
        pushIDs: null,
        textoPush: null,
        titulo: null,
        descricao: null,
        rating: 5,
        menu: false
    }),
    methods: { // ####################### Criar parte que criar documentos collections de cada escola ao realizar primeiro login do usuario Escola
        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${month}/${day}/${year}`
        },
        parseDate (date) {
            if (!date) return null

            const [month, day, year] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },

        criarOcorrencia(){

            // Log do sistema
            if(userProperties.escolaID != null){            
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('log_' + userProperties.escolaID).add({
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        perfil: userProperties.perfil,
                        
                        //slug: this.slug,
                        customtimestamp: customtimestamp,
                        dia: day,
                        mes: month,
                        ano: year,
                        acao: "criar",
                        categoria: "ocorrencias",
                        pontos: 10
                        
                    })
                    .then(docRef => {
                        console.log('Document written with ID: ', docRef.id);

                        
                    })
                    .catch(function (error) {
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
            

            if(userProperties.escolaID != null){
                this.loading = true
                // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second

                db.collection('ocorrencias').add({
                        nome: userProperties.nome,
                        imagemPerfil: userProperties.imagem,
                        escolaID: userProperties.escolaID,
                        slugAutor: userProperties.slug,
                        
                        slug: this.slug,
                        customtimestamp: customtimestamp,

                        date: this.date,

                        ano: this.date.substring(0,4),
                        mes: this.date.substring(5,7),
                        dia: this.date.substring(8,10),

                        titulo: this.titulo,
                        descricao: this.descricao,
                        rating: this.rating,
                        comentarioEscola: null
                    })
                    .then(docRef => {

                            console.log(this.pushIDs);
                            
                            function loop(item, index) {
                               var postData = {
                                    "notification": {        
                                        "title": "Nova ocorrência!",
                                        "body": "Uma nova ocorrência foi criada.",
                                        "click_action": "https://inclass.app",
                                        "icon": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                        "badge": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                        //"image": "https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/sistema%2Ficone-push%2Ficon-192x192-push.png?alt=media",
                                        "sound": "default"
                                    },    
                                    //"to": "egWUxBfoF_M:APA91bFI3XEPVD6dFP9W2_G__J9DzbTb9qpmFBW0NGRhcBTVxdNM_j_VOKo5V79Ro1-jmZLXYv6Wzq39ELzMUW-TTHAS7Nb6FSt762n_8E7SCwtHfFwn-QRClj3SD5mH2iO5sijMHY0a"
                                    "to": item
                                }

                                let axiosConfig = {
                                    headers: {
                                        'Content-Type': 'application/json',
                                        "Authorization": "key=AAAAiOjxl8Q:APA91bHly_RtJvUwP5kzHiHbulyRMI7oChExHjzyf1MFimlObjrX_-kRxCMWW77a2hBBxU7Oz-BhnFBANbCBHMObkiKAMHZSgxfw47LKjwGTRs6DCjtDkvvyRLiJcCMBHHh4uS93E0ha",
                                    }
                                };

                                axios.post('https://fcm.googleapis.com/fcm/send', postData, axiosConfig)
                                .then((res) => {
                                    console.log("PUSH ENVIADO. RESPONSE RECEIVED: ", res);
                                })
                                .catch((err) => {
                                    console.log("ERRO AO ENVIAR PUSH. AXIOS ERROR: ", err);
                                    alert("Erro no envio de push.")
                                })
                            }
                            this.pushIDs.forEach(loop);
                            


                            
                        
                        

                        console.log('Document written with ID: ', docRef.id);
                        //this.$router.push(`/${slug}/success`)
                        this.loading = false
                        this.dialog = true
                        
                    })
                    .catch( error => {
                        this.loading = false
                        console.log('Error adding document: ', error);
                        console.log("Erro no envio dos dados. Tente novamente mais tarde!")
                    })
            }
            else{
                alert("Sua sessão expirou, você será redirecionado para reautenticar!");
                this.$router.push(`/`);
            }
            
        },
        closeModal(){
            this.$router.push(`/ocorrencias-listagem`);
        },
        save() {
            this.menu = false;
        },
        submit() {
            if (this.$refs.form.validate() && this.statusUpload == true) {
            }
            if (this.$refs.form.validate() && this.statusUpload == false) {
                alert("Por favor, faça o upload da foto do perfil do usuário")
            } 
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        emogiRate(item){
            this.rating = item
        }
        
    },
    mounted() {
        const slug = this.generateUUID()
        this.slug = slug;
        var that = this;

        // se perfil não for escola ou administrador
        if(userProperties.perfil != 6){
            alert("Acesso negado!");
            this.$router.push(`/?redirect=`+window.location.pathname)
        }

        // Pega todos os token FCM da escola para enviar o push
        var tokensFMC = [];
        db.collection('usuarios').where("escolaID", "==", userProperties.escolaID)
        .get()
        .then((querySnapshot) => {
            querySnapshot.forEach(doc => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", doc.data());               
                let customObj = doc.data()
                // envia para perfil escola e administrativo
                if(customObj.tokenFMC != undefined && customObj.tokenFMC != "" && customObj.perfil > 1 && customObj.perfil < 4){
                    tokensFMC.push(customObj.tokenFMC)
                }
                    
            });

            //tokensFMC = tokensFMC.substring(0, tokensFMC.length -1);
            this.pushIDs = tokensFMC;

            this.loading = false;

        });
        

        $(".custom-rating a").click(function(){
            $(".custom-rating a").removeClass("selected");
            $(this).addClass("selected");
        })
    }
};
</script>

<style scoped>
    .loading{
        position: absolute;
        top:20%;
        left:48%;
        z-index: 2;
    }

    .btCirculo{
        height: 30px;
        width: 30px;
    }

    .btCirculo a{
        color:#fff;
    }

    progress{
        width:100%;
        margin-top: 6px;
    }

    label.v-label.theme--light{
        margin-bottom: 6px;
        display: block
    }

    .adicionarItem.btCirculo{
        position: relative;
        top: 12px;
        left: 5px;
    }

    .excluirItem.btCirculo{
        position: relative;
        left: 5px;
        top:-10px;
    }

    .box-items-selecionados{
        background: silver;
        width: 100%;
        padding: 20px 5px 5px 10px;
    }

    .container{
        padding: 0 0 !important;
    }

    .grid-list-sm img{
        width: 40%;
        height: auto !important;
    }

    .grid-list-sm a{
        min-height: 70px;
    }

    a.selected img{
        width: 60%;
        height: auto !important;
        cursor: pointer;
    }

    .label-rating{
        display: block;
        text-align: center
    }

    .buttonOk{
        position: absolute;
        right: 2px;
        bottom: 5px;
    }
    
</style>
